import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroBg from '../../assets/home/hero-community.jpg';

const HomeHero = () => {
  const navigate = useNavigate();

  return (
    <section
      className="gh-hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="gh-hero__scrim" aria-hidden="true" />
      <div className="gh-hero__content">
        <div className="gh-hero__lockup">
          <span className="gh-hero__lockup-name">GRIDx</span>
          <span className="gh-hero__lockup-tag">Smart Metering Solutions</span>
        </div>
        <h1 className="gh-hero__headline">
          Connected Communities.
          <br />
          Brighter Tomorrow.
        </h1>
        <p className="gh-hero__kicker">Reliable. Intelligent. Scalable.</p>
        <p className="gh-hero__body">
          The GRIDx smart meter connects homes, utilities and communities, enabling a
          smarter, more efficient and sustainable energy future.
        </p>
        <div className="gh-hero__actions">
          <button className="btn btn--primary" onClick={() => navigate('/gridx')}>
            Explore GRIDx
          </button>
          <button className="btn btn--outline-dark" onClick={() => navigate('/contact')}>
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
